
import hasModel from '@/mixins/hasModel'
import { mapState, mapMutations } from 'vuex'
export default {
    mixins: [hasModel],

    data() {
        return {
            data: {},
            legalField: false,
        }
    },

    computed: {
        ...mapState({
            user: (state) => state.auth.user,
            generatedModel: (state) => state.questionnaire.generatedModel,
        }),

        form() {
            return this.model?.form || {}
        },
    },

    methods: {
        ...mapMutations({
            clearTag: 'questionnaire/clearTag',
        }),

        submitForm() {
            if (this.form.ga_event)
                this.$ga?.event({
                    eventCategory: this.form.ga_event.eventCategory,
                    eventAction: this.form.ga_event.eventAction,
                    eventLabel: this.form.ga_event.eventLabel,
                    eventValue: this.form.ga_event.eventValue,
                })

            const password = Math.random().toString(36).slice(-8)
            const type = this.form.type || 'register'
            if (type == 'contact') {
                if (this.form.track) this.$track(this.form.track, this.$eventValues(this.data, this.form.track_custom || {}))
                if (this.form.klaviyo) {
                    if (Array.isArray(this.form.klaviyo)) this.form.klaviyo.map((klaviyo) => this.$store.dispatch('klaviyo/event', klaviyo))
                    else this.$store.dispatch('klaviyo/event', this.form.klaviyo)
                }
                this.$axios.$post('/api/v1/auth/contact', { ...this.data, tag: this.form.tag, klaviyo: this.form.klaviyo } ).then(() => {
                    this.$store.dispatch('questionnaire/clear').then(() => {
                        this.redirect()
                    })
                })
            } else {
                if (!this.$auth.loggedIn) {
                    this.$store.dispatch('user/register', { email: this.data.email, password, type: this.form.type || 'register' }).then(() => {
                        this.$cookies.set('temporary-password', password)
                        this.$trackEvent('REGISTER')
                        this.saveUser()
                    })
                } else this.saveUser()
            }
        },

        saveUser() {
            this.$store.dispatch('questionnaire/setModel', { ...this.data, email: this.user.email }).then(() => {
                this.$store
                    .dispatch('questionnaire/generateModel', {
                        ...this.user,
                        ...{ wedding_details: { ...this.user.wedding_details, style_quiz: this.user.wedding_details.style_quiz || null } },
                    })
                    .then(() => {
                        this.$store.dispatch('user/update', this.generatedModel).then(() => {
                            this.trackUser()
                            this.$trackEvent('FORM_SUBMITTED')
                            this.$store.dispatch('questionnaire/clear').then(() => {
                                this.redirect()
                            })
                        })
                    })
            })
        },

        redirect() {
            if (this.form.redirect) this.$router.push({ path: this.form.redirect })
            else this.$router.push({ name: 'dashboard' })
        },

        trackUser() {
            if (this.form.track) this.$track(this.form.track, this.$eventValues(this.data, this.form.track_custom || {}))
            if (this.form.tag) this.$axios.$post('/api/v1/users/me/tag', { tag: this.form.tag })
            if (this.form.klaviyo) {
                if (Array.isArray(this.form.klaviyo)) this.form.klaviyo.map((klaviyo) => this.$store.dispatch('klaviyo/event', klaviyo))
                else this.$store.dispatch('klaviyo/event', this.form.klaviyo)
            }
        },
    },
}
